import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-landing-anonymous',
  templateUrl: './landing-anonymous.component.html',
  styleUrls: ['./landing-anonymous.component.scss']
})
export class LandingAnonymousComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
